import { YCountryId, YDateString, YId, YPaymentProvider } from '../y/types';

export type EPaymentMethodType = 'card' | 'account' | 'paypal' | 'unknown';

export interface EPaymentMethod {
    id: YId;
    user_id?: YId;
    is_active: boolean;
    provider: YPaymentProvider;
    token: string;
    type: EPaymentMethodType;
    fingerprint?: string;
    country?: YCountryId;
    bank?: string;
    account?: string;
    email?: string;
    subtype?: string;
    display_digits?: string;
    expiration?: YDateString;
}

export function ePaymentMethodDescription(method: EPaymentMethod) {
    switch(method.type) {
        case 'card':
            return method.subtype + ' XXXX XXXX XXXX ' + method.display_digits;

        case 'account':
            return method.bank + ' XXXXXXXXX ' + method.account;

        case 'paypal':
            return "Paypal" + method.email;
    }

    return '';
}
